import gql from 'graphql-tag';

export const POSITION_FRAGMENT = gql`
  fragment PositionDetails on Position {
    id
    canEditPosition
    dailyProjectPrompts
    dailyProjectPromptsUseSubprojects
    cursor
    level
    manageBudgets
    viewBudgets
    manageCompanySettings
    manageCostCodes
    manageEmployeeGroups
    manageEmployees
    manageEquipment
    manageMediaCollection
    manageProjectGroups
    manageProjects
    manageSchedule
    manageTimeEntries
    memberLock
    organizationId
    requestSignatures
    scopeByGroup
    submittedOn
    timeEvents
    title
    viewAllActivityReport
    viewEquipmentDetails
    viewEquipmentStatus
    viewMemberActivityReport
    viewMemberExpenses
    viewProjectExpenses
    viewSchedule
    clockInRestriction
    clockInRestrictionStartTime
    canManageProjectCostCodeQuantity
    photoVerificationSettings
    jobCostingPrompt
    updatedOn
    createdOn
    deletedOn
    manageBulletinPosts
  }
`;
export const POSITION_QUERY = gql`
  query QueryFlatPositions($first: Int, $after: String, $filter: PositionFilter) {
    positions(first: $first, after: $after, filter: $filter, sort: [{ level: asc }]) {
      cursor
      __typename
      ...PositionDetails
    }
  }
  ${POSITION_FRAGMENT}
`;

export const POSITION_TITLE_QUERY = gql`
  query queryPositionWithTitle($first: Int, $after: String, $filter: PositionFilter) {
    positions(first: $first, after: $after, filter: $filter, sort: [{ level: asc }]) {
      cursor
      id
      title
    }
  }
`;
